import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Alert, Button, Panel } from "components/bootstrap";
const FlexyWrap = styled.div`
  display: flex;
  align-items: center;
`;
const ShortContent = styled.p`
  flex: 1;
  margin: 0;
  font-weight: bold;
`;
const LongContent = styled.div(
  ({ $visible }) => css`
    white-space: pre-wrap;
    display: ${$visible ? "block" : "none"};
    padding-top: 12px;
  `
);
const NotificationExample = ({
  bsStyle,
  shortMessage,
  longMessage = void 0,
  hiddenTitle = false,
  title,
  dismissible = false
}) => {
  const { t } = useTranslation("enterprise_customization");
  const [showReadMore, setShowReadMore] = useState(false);
  const toggleReadMore = () => {
    setShowReadMore(!showReadMore);
  };
  if (!title || !shortMessage) {
    return /* @__PURE__ */ React.createElement(Panel, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "notifications.example_incomplete", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })));
  }
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle, onDismiss: dismissible ? () => {
  } : void 0, title: !hiddenTitle && title }, /* @__PURE__ */ React.createElement(FlexyWrap, null, /* @__PURE__ */ React.createElement(ShortContent, null, shortMessage), longMessage && /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: toggleReadMore }, showReadMore ? t("notifications.read_less") : t("notifications.read_more"))), longMessage && /* @__PURE__ */ React.createElement(LongContent, { $visible: showReadMore }, longMessage));
};
export default NotificationExample;
